import {getRecommendKeyword} from '@/api/help/home';
import {useQuery} from '@tanstack/react-query';

export const useGetRecommendKeyword = () => {
  return useQuery({
    queryKey: ['help', 'faq', 'recommendKeyword'],
    queryFn: getRecommendKeyword,
    select: (data) => data.data.keywordList,
  });
};
